import Slider from '../../../framework/slider';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';

type addBgImageType = (carousel:NodeListOf<HTMLElement>, carouselDots:HTMLElement) => void;
type resetProgressBarType = () => void;
type startProgressBarType = () => void;
type startAnimationType = (fps:number) => void;
type animateCarouselType = () => void;
type addSubscriptionsType = () => void;
type initializeLoryType = () => void;
type resetAnimationType = () => void;

const fps = 0.14;
export default class CarouselTwo extends Slider {
    private readonly progressBar: HTMLElement | null;
	private timeLeft: ReturnType<typeof setInterval> | undefined;
    private frameId: number;
    private timeNow: number;
    private timeThen: number;
    private timeElapsed: number;
    private fpsInterval: number;

	constructor(element:HTMLElement) {
		const isExperienceEditor = document.body.classList.contains('isSitecoreEditor');
		super({
			element,
			dotContainer: '.v2-slider__dots',
			slideContainer: '.v2-slider',
			createBullets: true,
			sliderOpts: {
				infinite: isExperienceEditor ? false : 1
			}
		});
		this.initializeLory();
		this.publishBreakpointOnResize();
		this.addSubscriptions();
		// Device check
		const carousel:NodeListOf<HTMLElement> = document.querySelectorAll('.v2-slider__slide--carousel');
		this.progressBar = this.element.querySelector('.v2-slider__progress-bar');
		const carouselDots: HTMLElement = this.element.querySelector('ul.v2-slider__dots');
		this.timeLeft = undefined;

		if (carouselDots) {
			this.addBgImage.bind(this, carousel, carouselDots)();
			this.addEventListener(carouselDots, 'click', (evt:Event) => {
				if ((evt.target as HTMLElement)?.closest('li')) {
					this.resetCarouselAnimation();
				}
			});
			window.addEventListener('resize', () => {
				this.addBgImage.bind(this, carousel, carouselDots)();
			});
		}
		if (!screenSmallerThan('sm')) {
			this.element.addEventListener('after.lory.slide', () => {
				if (this.progressBar) {
					clearInterval(this.timeLeft);
					this.resetProgressBar();
				} else {
					this.resetCarouselAnimation();
				}
			});
			// Check the progress Bar
			if (this.progressBar) {
				this.startProgressBar();
			} else {
				this.startCarouselAnimation(0.14); // value 0.14 is used for taking 7000 as fpsInterval.
			}
		} else {
			this.resetCarouselAnimation();
		}
	}

	resetProgressBar: resetProgressBarType = ():void => {
		if(this.progressBar)this.progressBar.style.width = '0';
		this.startProgressBar();
	}

	startProgressBar: startProgressBarType = ():void => {
		let width = 1;
		this.timeLeft = setInterval(() => {
			if (width >= 100) {
				clearInterval(this.timeLeft);
				if (this.slider) this.slider.next();
			} else {
				width++;
				if(this.progressBar)this.progressBar.style.width = width + '%';
			}
		}, 70);
	}

	resetCarouselAnimation: resetAnimationType = ():void =>{
		window.cancelAnimationFrame(this.frameId);
		this.startCarouselAnimation(fps);
	}

	startCarouselAnimation: startAnimationType = (fps):void => {
		this.fpsInterval = 1000 / fps;
		this.timeThen = Date.now();
		this.animateCarouselSlide();
	}

	// Function to call recursively after 7 seconds
	animateCarouselSlide: animateCarouselType = ():void => {
		this.frameId = requestAnimationFrame(this.animateCarouselSlide.bind(this));
		this.timeNow = Date.now();
		this.timeElapsed = this.timeNow - this.timeThen;
		if (this.timeElapsed > this.fpsInterval && this.slider) {
			this.timeThen = this.timeNow - (this.timeElapsed % this.fpsInterval);
			this.slider.next();
		}
	}

	addSubscriptions: addSubscriptionsType = ():void => {
		this.subscribe('SITE.BREAKPOINT', this.initializeLory.bind(this));
	}

	// Check mobile and desktop and add bg-image
	addBgImage: addBgImageType = (carousel, carouselDots):void => {
		carousel.forEach(slide => {
			if (screenSmallerThan('sm')) {
				const img:HTMLImageElement|null = slide.querySelector('.v2-slider__slide--carousel--col img');
				// Check Carousel item image
				if (img?.dataset?.mhide?.toLowerCase() === 'true') {
					(img.parentElement as HTMLElement).classList.add('v2-hidden');
				}
			}
		});
        const parentNode = this.progressBar?.parentNode as HTMLElement;
		if (screenSmallerThan('sm')) {            
			if (parentNode?.classList) parentNode.classList.add('v2-hidden');			
			if (carouselDots?.classList) carouselDots.classList.remove('v2-hidden');
		} else if (parentNode?.classList?.contains('v2-hidden')) {
			parentNode.classList.remove('v2-hidden');
			carouselDots.classList.add('v2-hidden');
		}
	}

	initializeLory:initializeLoryType = ():void => {
		if (!this.slider && this.dotCount > 1) {
			this.initLory(this.slideContainer);
		}
	}
}
